import Link from 'next/link'
import PropTypes from 'prop-types'

import { isPresent } from 'utils'

import Header from 'components/Header'
import Spacer from 'components/Spacer'
import SubHeader from 'components/SubHeader'
import Text from 'components/Text'

import { BackLink, Image, Main, Root, RootInner, Summary, Wrapper } from './ArticleHeader.style'
import BackSvg from './svg/back.svg'

const loader = ({ src, width, quality }) => {
  return `${src}&w=${width}&q=${quality || 75}&ar=6:4&fit=crop`
}

const ArticleHeader = ({ imageUrl, category, title, summary }) => {
  return (
    <Wrapper>
      {isPresent(imageUrl) && <Image loader={loader} width="600" height="400" src={imageUrl} alt="" sizes="100vw" />}
      <Root>
        <RootInner>
          <Link href="/journal" passHref legacyBehavior>
            <BackLink>
              <BackSvg />
              <Text>Back to all Articles</Text>
            </BackLink>
          </Link>
          <Main>
            <SubHeader>{category}</SubHeader>
            <Spacer y={4} />
            <Header size="lg">{title}</Header>
            <Spacer y={6} />
            <Summary>
              <Text html={summary} size="xl" />
            </Summary>
          </Main>
        </RootInner>
      </Root>
    </Wrapper>
  )
}

// TODO: Header styles
ArticleHeader.propTypes = {
  imageUrl: PropTypes.string,
  category: PropTypes.string,
  title: PropTypes.string,
  summary: PropTypes.string,
}

ArticleHeader.defaultProps = {}

export default ArticleHeader
